import { Outlet } from 'react-router-dom';
import { I18nProvider } from './contexts/i18n';
import { SessionProvider } from './contexts/session';
import { ThemeProvider } from './contexts/theme';
import { useDisableDevTools } from './scripts/utils/devUtils';

function App() {
  useDisableDevTools();

  return (
    <I18nProvider>
      <ThemeProvider>
        <SessionProvider>
          <Outlet></Outlet>
        </SessionProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
